import { useLanguage } from "@/contexts/LanguageContext";
import { Language, languageFlags, languageNames } from "@/i18n/translations";
import { useState, useRef, useEffect } from "react";
import { Globe } from "lucide-react";

const languages: Language[] = ["he", "en", "ru"];

const FlagImg = ({ code }: { code: string }) => (
  <img
    src={`https://flagcdn.com/w40/${code}.png`}
    alt={code}
    width={22}
    height={16}
    className="rounded-sm object-cover"
    style={{ width: 22, height: 16 }}
  />
);

const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-3 py-2 rounded-full border neon-border bg-muted/30 hover:neon-glow-cyan transition-all duration-300 text-sm font-medium text-foreground"
      >
        <FlagImg code={languageFlags[lang]} />
        <Globe className="w-4 h-4 text-primary" />
      </button>

      {open && (
        <div className="absolute top-full mt-2 neon-card neon-glow-cyan overflow-hidden z-50 min-w-[140px]"
          style={{ left: "50%", transform: "translateX(-50%)" }}
        >
          {languages.map((l) => (
            <button
              key={l}
              onClick={() => { setLang(l); setOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm transition-all duration-200 ${
                l === lang ? "bg-primary/15 neon-text-cyan font-semibold" : "text-foreground hover:bg-primary/5"
              }`}
            >
              <FlagImg code={languageFlags[l]} />
              <span>{languageNames[l]}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
